import './winmock7/style';
import FormStructure from './winmock7/form_structure';

export default FormStructure;